module.exports = __webpack_public_path__ + "img/10a)Schlosshotel- Velden.jpg";